<style lang="less">
    .shape-context {
        min-width: max-content !important;
        max-width: 500px;
    }
</style>
<i18n>
{
  "zh": {
    "rightMoveColumn": "向右移动一列",
    "leftMoveColumn": "向左移动一列",
    "deleteColumn": "删除列",
    "selectAll": "选择全部",
    "addTaskBefore": "在此前新增任务",
    "addTaskAfter": "在此后新增任务",
    "subTask": "为此任务新增子任务",
    "delete": "删除任务",
    "redLine": "今日红线",
    "showFloatPanel": "显示浮动面板",
    "indent": "缩进",
    "outdent": "凸排",
    "moveUpTask": "上移任务",
    "moveDownTask": "下移任务",
    "expandAllTask": "展开所有子任务",
    "collapseAllTask": "折叠所有子任务",
    "hyperLink": "超链接",
    "addLeftLabel": "在进度条左侧添加标签",
    "addRightLabel": "在进度条右侧添加标签",
    "deleteRightLabel": "删除右标签",
    "deleteLeftLabel": "删除左标签",
    "createTimeline": "创建时间线",
    "insertCol": "插入列",
    "hideCol": "隐藏列",
    "options": "选项",
    "aiGantt": "AI助手"
  },
  "en": {
    "rightMoveColumn": "Right Move Column",
    "leftMoveColumn": "Left Move Column",
    "deleteColumn": "Delete Column",
    "selectAll": "Select All",
    "addTaskBefore": "Insert Before",
    "addTaskAfter": "Insert After",
    "subTask": "Add Subtask",
    "delete": "Delete",
    "redLine": "Current Date Line",
    "showFloatPanel": "Show Float Panel",
    "indent": "Indent",
    "outdent": "Outdent",
    "moveUpTask": "Move Up Task",
    "moveDownTask": "Move Down Task",
    "expandAllTask": "Expand All Subtask",
    "collapseAllTask": "Collapse All Subtask",
    "hyperLink": "Hyperlink",
    "addLeftLabel": "Add Left Label",
    "addRightLabel": "Add Right Label",
    "deleteRightLabel": "Delete Right Label",
    "deleteLeftLabel": "Delete Left Label",
    "createTimeline": "Create Timeline",
    "insertCol": "Insert Column",
    "hideCol": "Hide Column",
    "options": "Options",
    "aiGantt": "AI Assist"
  },
  "fr": {
    "rightMoveColumn": "Right Move Column",
    "leftMoveColumn": "Left Move Column",
    "deleteColumn": "Delete Column",
    "selectAll": "Tout sélectionner",
    "addTaskBefore": "Insérer avant",
    "addTaskAfter": "Insérer après",
    "subTask": "Ajouter une sous-tâche",
    "showFloatPanel": "Afficher le panneau flottant",
    "delete": "Supprimer",
    "redLine": "la ligne de date actuelle",
    "indent": "échancrure",
    "outdent": "Rangée convexe",
    "expandAllTask": "Développez toutes les sous-tâches",
    "collapseAllTask": "Réduire toutes les sous-tâches",
    "moveUpTask": "Déplacer la tâche vers le haut",
    "moveDownTask": "Déplacer la tâche vers le bas",
    "hyperLink": "Hyperliens",
    "addLeftLabel": "Ajouter un libellé à gauche",
    "addRightLabel": "Ajouter un libellé à droite",
    "deleteRightLabel": "Supprimer l'étiquette de droite",
    "deleteLeftLabel": "Supprimer l'étiquette de gauche",
    "createTimeline": "Créer une chronologie",
    "insertCol": "Insérer une colonne",
    "hideCol": "Masquer la colonne",
    "aiGantt": "Assistance IA",
    "options": "Options"
  },
  "de": {
    "rightMoveColumn": "Right Move Column",
    "leftMoveColumn": "Left Move Column",
    "deleteColumn": "Delete Column",
    "selectAll": "Wählen Sie Alle",
    "addTaskBefore": "Davor einfügen",
    "addTaskAfter": "Danach einfügen",
    "subTask": "Unteraufgabe hinzufügen",
    "showFloatPanel": "Float Panel anzeigen",
    "delete": "Löschen",
    "redLine": "Datumszeile anzeigen",
    "indent": "Vertiefung",
    "outdent": "Konvexe Reihe",
    "expandAllTask": "Alle Unteraufgaben ausklappen",
    "collapseAllTask": "Alle Unteraufgaben einklappen",
    "moveUpTask": "Move tasks up",
    "moveDownTask": "Move tasks down",
    "hyperLink": "Hyperlinks",
    "addLeftLabel": "Linke Bezeichnung hinzufügen",
    "addRightLabel": "Rechte Bezeichnung hinzufügen",
    "deleteRightLabel": "Entfernen Sie das rechte Etikett",
    "deleteLeftLabel": "Entfernen Sie das linke Etikett",
    "createTimeline": "Erstellen Sie eine Zeitleiste",
    "insertCol": "Spalte einfügen",
    "hideCol": "Spalte ausblenden",
    "aiGantt": "KI-Assistenz",
    "options": "Optionen"
  },
  "jp": {
    "rightMoveColumn": "Right Move Column",
    "leftMoveColumn": "Left Move Column",
    "deleteColumn": "Delete Column",
    "selectAll": "すべて選択",
    "addTaskBefore": "前に挿入",
    "addTaskAfter": "後に挿入",
    "subTask": "サブタスクを追加",
    "showFloatPanel": "フローティングパネルを表示",
    "delete": "削除",
    "redLine": "現在の日付線",
    "indent": "インデント",
    "outdent": "凸列",
    "expandAllTask": "すべてのサブタスクを展開",
    "collapseAllTask": "すべてのサブタスクを折りたたむ",
    "moveUpTask": "タスクを上に移動",
    "moveDownTask": "タスクを下に移動",
    "hyperLink": "ハイパーリンク",
    "addLeftLabel": "左ラベルを追加",
    "addRightLabel": "右ラベルを追加",
    "deleteRightLabel": "右のラベルを削除します",
    "deleteLeftLabel": "左のラベルを削除します",
    "createTimeline": "タイムラインを作成する",
    "insertCol": "列を挿入",
    "hideCol": "列を非表示",
    "aiGantt": "AIアシスト",
    "options": "オプション"
  },
  "es": {
    "rightMoveColumn": "Right Move Column",
    "leftMoveColumn": "Left Move Column",
    "deleteColumn": "Delete Column",
    "selectAll": "Seleccionar todo",
    "addTaskBefore": "Insertar antes",
    "addTaskAfter": "Insertar después",
    "subTask": "Añadir subtarea",
    "showFloatPanel": "Mostrar panel flotante",
    "delete": "Eliminar",
    "redLine": "Línea de Fecha Actual",
    "indent": "sangría",
    "outdent": "Fila convexa",
    "expandAllTask": "Expandir todas las subtareas",
    "collapseAllTask": "Ocultar todas las subtareas",
    "moveUpTask": "Subir tarea",
    "moveDownTask": "Bajar tarea",
    "hyperLink": "Hipervínculos",
    "addLeftLabel": "Añadir etiqueta izquierda",
    "addRightLabel": "Añadir etiqueta derecha",
    "deleteRightLabel": "Quitar etiqueta de la derecha",
    "deleteLeftLabel": "Quitar etiqueta izquierda",
    "createTimeline": "Crea una cronología",
    "insertCol": "Insertar columna",
    "hideCol": "Ocultar columna",
    "aiGantt": "Asistencia IA",
    "options": "Opciones"
  },
  "pt": {
    "rightMoveColumn": "Right Move Column",
    "leftMoveColumn": "Left Move Column",
    "deleteColumn": "Delete Column",
    "selectAll": "Selecionar tudo",
    "addTaskBefore": "Inserir antes",
    "addTaskAfter": "Inserir após",
    "subTask": "Adicionar subtarefa",
    "showFloatPanel": "Mostrar painel flutuante",
    "delete": "Excluir",
    "redLine": "Linha de Data Atual",
    "indent": "recuo",
    "outdent": "Linha convexa",
    "expandAllTask": "Expandir todas as subtarefas",
    "collapseAllTask": "Recolher todas as subtarefas",
    "moveUpTask": "Mover tarefa para cima",
    "moveDownTask": "Mover tarefa para baixo",
    "hyperLink": "Hiperlinks",
    "addLeftLabel": "Adicionar Etiqueta à esquerda",
    "addRightLabel": "Adicionar Etiqueta à direita",
    "deleteRightLabel": "Remover etiqueta certa",
    "deleteLeftLabel": "Remover etiqueta esquerda",
    "createTimeline": "Crie uma linha do tempo",
    "insertCol": "Inserir coluna",
    "hideCol": "Esconder a Coluna",
    "aiGantt": "Assistência IA",
    "options": "Opções"
  },
  "it": {
    "rightMoveColumn": "Right Move Column",
    "leftMoveColumn": "Left Move Column",
    "deleteColumn": "Delete Column",
    "selectAll": "Seleziona tutto",
    "addTaskBefore": "Inserire prima",
    "addTaskAfter": "Inserisci dopo",
    "subTask": "Aggiungi attività secondaria",
    "showFloatPanel": "Mostra pannello mobile",
    "delete": "Elimina",
    "redLine": "la riga della data corrente",
    "indent": "rientranza",
    "outdent": "Fila convessa",
    "expandAllTask": "Espandi tutte le attività secondarie",
    "collapseAllTask": "Comprimi tutte le attività secondarie",
    "moveUpTask": "Sposta l'attività in alto",
    "moveDownTask": "Sposta l'attività in basso",
    "hyperLink": "Collegamenti ipertestuali",
    "addLeftLabel": "Aggiungi etichetta sinistra",
    "addRightLabel": "Aggiungi etichetta destra",
    "deleteRightLabel": "Rimuovi l'etichetta giusta",
    "deleteLeftLabel": "Rimuovi l'etichetta sinistra",
    "createTimeline": "Crea una sequenza temporale",
    "insertCol": "Inserisci colonna",
    "hideCol": "Nascondi colonna",
    "aiGantt": "Assistenza IA",
    "options": "Opzioni"
  },
  "tw": {
    "rightMoveColumn": "Right Move Column",
    "leftMoveColumn": "Left Move Column",
    "deleteColumn": "Delete Column",
    "selectAll": "全選",
    "addTaskBefore": "在此前插入",
    "addTaskAfter": "在此後插入",
    "subTask": "新增子工作",
    "delete": "刪除",
    "redLine": "今日紅線",
    "showFloatPanel": "顯示浮動面板",
    "indent": "縮排",
    "outdent": "凸排",
    "expandAllTask": "展開所有子工作",
    "collapseAllTask": "摺疊所有子工作",
    "moveUpTask": "向上移動任務",
    "moveDownTask": "向下移動任務",
    "hyperLink": "超連結",
    "addLeftLabel": "新增左側標籤",
    "addRightLabel": "新增右側標籤",
    "deleteRightLabel": "刪除右標籤",
    "deleteLeftLabel": "刪除左標籤",
    "createTimeline": "建立時間線",
    "insertCol": "插入欄",
    "hideCol": "隱藏欄",
    "aiGantt": "AI協助",
    "options": "選項"
  }
}
</i18n>
<template>
    <MenuList
        :menuList="menuList"
        @mouseover.stop
        :style="contextStyle"
        @handleClicks="handleClicks(...arguments)"
        @handleMouseenter="handleMouseenter(...arguments)"
    />
</template>

<script lang="ts">
    import { Component, Prop, Vue, Inject } from "vue-property-decorator";
    enum eGanttType {
        SelectAll,
        NewTask,
        NewSubTask,
        DeleteTask,
        Indent,
        Outdent,
        HideColumn,
        LinkTasks,
        UnlinkTasks,
        Forward,
        Backward,
        GotoTask,
        GotoTaskEnd,
        AddLeftLabel,
        AddRightLabel,
        NewTaskAfter,
        MoveUpTasks,
        MoveDownTasks,
        changeRowHeight,
        NewTaskBefore,
        DeleteLeftLabel,
        DeleteRightLabel,
        InsertColumn,
        DeleteColumn,
        MoveColToForward,
        MoveColToBack,
        TodayLine,
    }
    declare var EDDocument: any;
    import appConfig from "@/public/globalConfig";
    import MenuList from "@/app/components/MenuList.vue";

    @Component({
        components: {
            MenuList,
        },
    })
    export default class GanttRightMenu extends Vue {
        @Inject()
        ["showMessage"];
        showOpenLibrary = !appConfig.isBuild;
        libraryWorkerURL: string = appConfig.libraryWorkerURL;

        get isShowTodayLine() {
            return this.$store.state.gantt.isShowTodayLine;
        }
        get menuList() {
            let resultList = this.isSelectRow ? this.menuListRow : this.isSelectColumn ? this.menuListCol : [];
            return { container: "shape-context", list: resultList };
        }
        get menuListRow() {
            let listRow = [
                { key: "selectAll", disabled: !this.isGantt },
                { divide: true },
                { key: "aiGantt", expand: true, img: require(`@/app/assets/img/ai4/ai-chat-icon${window.EDCONFIG.IS_SDK ? "-sdk" : ""}.svg`) },
                { divide: true },
                {
                    key: "addTaskBefore",
                    disabled: !this.isSelectTask || this.isSelectAll || !this.isGantt,
                    img: "gantt-add-above",
                },
                {
                    key: "addTaskAfter",
                    disabled: !this.isSelectTask || this.isSelectAll || !this.isGantt,
                    img: "gantt-add-below",
                },
                {
                    key: "subTask",
                    disabled: !this.isSelectTask || this.isSelectAll || !this.isGantt,
                    img: "gantt-subtask",
                },
                {
                    key: "delete",
                    disabled: !this.isGantt,
                    img: "gantt-delete",
                },
                // { key: "showFloatPanel", disabled: this.isShowGanttFloatPanel },
                { divide: true },
                { key: "redLine", disabled: !this.isGantt, checked: this.isShowTodayLine },
                { divide: true },
                { key: "indent", disabled: !this.isIndent },
                { key: "outdent", disabled: !this.isOutdent },
                { key: "moveUpTask", disabled: !this.isSelectTask || !this.isCanMoveUpTask },
                { key: "moveDownTask", disabled: !this.isSelectTask || !this.isCanMoveDownTask },
                { key: "expandAllTask", disabled: !this.isExpandAllSubTask },
                { key: "collapseAllTask", disabled: !this.isHideAllSubTask },
                { divide: true },
                {
                    key: "addLeftLabel",
                    disabled: !this.isSelectTask || this.isSelectAll || !this.isGantt || this.isAddLeftLabel,
                },
                {
                    key: "addRightLabel",
                    disabled: !this.isSelectTask || this.isSelectAll || !this.isGantt || this.isAddRightLabel,
                },
                { key: "deleteLeftLabel", disabled: !this.isSelectTask || !this.isAddLeftLabel },
                { key: "deleteRightLabel", disabled: !this.isSelectTask || !this.isAddRightLabel },
                { divide: true },
                // { key: "createTimeline", isRender: this.isGantt, disabled: !this.isHideAllSubTask },
                // { divide: true },
                // { key: "options", disabled: !this.isGantt }
            ];
            let resultListRow = [];
            listRow.map((i) => {
                resultListRow.push(Object.assign({}, i, { label: this.$t(i.key) }));
            });
            return resultListRow;
        }
        get menuListCol() {
            let listCol = [
                {
                    key: "insertCol",
                    disabled: !this.isGantt,
                    img: "gantt-right-menu-insert-column",
                },
                {
                    key: "hideCol",
                    disabled: !this.isGantt || this.showColNum <= 2,
                    img: "gantt-right-menu-hidden-column",
                },
                {
                    key: "deleteColumn",
                    disabled: !this.isSelectIdOrNameColumn,
                    img: "gantt-right-menu-delete-column",
                },
                { divide: true },
                {
                    key: "rightMoveColumn",
                    disabled: !this.isMovetColToRightEnable,
                    img: "gantt-right-menu-right-move-column",
                },
                {
                    key: "leftMoveColumn",
                    disabled: !this.isMoveColToLeftEnable,
                    img: "gantt-right-menu-left-move-column",
                },
                { divide: true },
                {
                    key: "options",
                    disabled: !this.isGantt,
                    img: "gantt-right-menu-global-settings",
                },
            ];
            let resultListCol = [];
            listCol.map((i) => {
                resultListCol.push(Object.assign({}, i, { label: this.$t(i.key) }));
            });
            return resultListCol;
        }
        handleClicks(...args) {
            let key = args[0];
            let clickEvents = new Map([
                [
                    "selectAll",
                    () => {
                        this.selectAllTasks();
                    },
                ],
                [
                    "addTaskBefore",
                    () => {
                        this.addTaskBefore();
                    },
                ],
                [
                    "addTaskAfter",
                    () => {
                        this.addTaskAfter();
                    },
                ],
                [
                    "subTask",
                    () => {
                        this.addSubTask();
                    },
                ],
                [
                    "delete",
                    () => {
                        this.deleteTask();
                    },
                ],
                [
                    "redLine",
                    () => {
                        this.toggleTodayLine();
                    },
                ],
                [
                    "showFloatPanel",
                    () => {
                        this.showGanttFloatPanel();
                    },
                ],
                [
                    "indent",
                    () => {
                        this.inDent();
                    },
                ],
                [
                    "outdent",
                    () => {
                        this.outDent();
                    },
                ],
                [
                    "moveUpTask",
                    () => {
                        this.moveUpTask();
                    },
                ],
                [
                    "moveDownTask",
                    () => {
                        this.moveDownTask();
                    },
                ],
                [
                    "expandAllTask",
                    () => {
                        this.expandAllSubTask();
                    },
                ],
                [
                    "collapseAllTask",
                    () => {
                        this.collapsedAllSubTask();
                    },
                ],
                [
                    "addLeftLabel",
                    () => {
                        this.addLeftLabel();
                    },
                ],
                [
                    "addRightLabel",
                    () => {
                        this.addRightLabel();
                    },
                ],
                [
                    "deleteLeftLabel",
                    () => {
                        this.deleteLeftLabel();
                    },
                ],
                [
                    "deleteRightLabel",
                    () => {
                        this.deleteRightLabel();
                    },
                ],
                // [ "createTimeline", () => { this.collapsedAllSubTask() }],
                [
                    "options",
                    () => {
                        this.clickOption();
                    },
                ],
                [
                    "insertCol",
                    () => {
                        this.InsertColumn();
                    },
                ],
                [
                    "hideCol",
                    () => {
                        this.HideColumn();
                    },
                ],
                [
                    "deleteColumn",
                    () => {
                        this.DeleteColumn();
                    },
                ],
                [
                    "rightMoveColumn",
                    () => {
                        this.moveColToBack();
                    },
                ],
                [
                    "leftMoveColumn",
                    () => {
                        this.moveColumnToForward();
                    },
                ],
                [
                    "options",
                    () => {
                        this.clickOption();
                    },
                ],
            ]);
            const onClicks = clickEvents.get(key);
            onClicks && onClicks();
        }
        handleMouseenter(...args) {
            let key = args[0],
                event = args[1];
            let node = <HTMLElement>event.target;
            let ts: any = this;
            ts.$bus.$emit("changeContextType", key, node.offsetTop - (<HTMLElement>node.parentElement).scrollTop);
            if (key == "aiGantt") {
                this.$store.commit("setStatus", {
                    type: "showContextExpand",
                    data: true,
                });
                ts.$bus.$emit("changeExpandPosition");
            }
        }
        closeContext() {
            this.$store.commit("closeContext");
        }
        expandAllSubTask() {
            let view = window["_view"];
            if (view._activeShape && view._activeShape.toGantt()) {
                let gantt = view._activeShape.toGantt();
                if (!gantt) return;
                gantt.ShowOrhideSubTask(false);
                this.$store.state.gantt.isHideAllTask = true;
                this.$store.state.gantt.isExpandAllTask = false;
                this.closeContext();
            }
        }
        collapsedAllSubTask() {
            let view = window["_view"];
            if (view._activeShape && view._activeShape.toGantt()) {
                let gantt = view._activeShape.toGantt();
                if (!gantt) return;
                gantt.ShowOrhideSubTask(true);
                this.$store.state.gantt.isHideAllTask = false;
                this.$store.state.gantt.isExpandAllTask = true;
                this.closeContext();
            }
        }
        moveUpTask() {
            let view = window["_view"];
            view.ganttOperation(eGanttType.MoveUpTasks, "Move Up Task");
            this.closeContext();
        }
        moveDownTask() {
            let view = window["_view"];
            view.ganttOperation(eGanttType.MoveDownTasks, "Move Down Task");
            this.closeContext();
        }
        selectAllTasks() {
            let view = window["_view"];
            view.ganttOperation(eGanttType.SelectAll, "Select All Tasks");
            this.closeContext();
        }
        deleteTask() {
            let view = window["_view"];
            view.ganttOperation(eGanttType.DeleteTask, "Delete");
            this.closeContext();
        }
        toggleTodayLine() {
            let view = window["_view"];
            view.ganttOperation(eGanttType.TodayLine, "Today line");
        }
        addSubTask() {
            let view = window["_view"];
            view.ganttOperation(eGanttType.NewSubTask, "New Sub Task");
            this.closeContext();
        }
        addTaskBefore() {
            let view = window["_view"];
            view.ganttOperation(eGanttType.NewTaskBefore, "Add Task Before");
            this.closeContext();
        }
        addTaskAfter() {
            let view = window["_view"];
            view.ganttOperation(eGanttType.NewTaskAfter, "Add Task After");
            this.closeContext();
        }
        inDent() {
            let view = window["_view"];
            view.ganttOperation(eGanttType.Indent, "Indent");
            this.$store.commit("setGanttState", { type: "isIndent", data: view.canIdent() });
            this.closeContext();
        }
        outDent() {
            let view = window["_view"];
            view.ganttOperation(eGanttType.Outdent, "OutDent");
            this.$store.commit("setGanttState", { type: "isOutdent", data: view.canOutdent() });
            this.closeContext();
        }
        addLeftLabel() {
            let view = window["_view"];
            view.ganttOperation(eGanttType.AddLeftLabel, " Add Left Label");
            this.closeContext();
        }
        addRightLabel() {
            let view = window["_view"];
            view.ganttOperation(eGanttType.AddRightLabel, "Add Right Label");
            this.closeContext();
        }
        deleteLeftLabel() {
            let view = window["_view"];
            view.ganttOperation(eGanttType.DeleteLeftLabel, "Delete left Label");
            this.closeContext();
        }
        deleteRightLabel() {
            let view = window["_view"];
            view.ganttOperation(eGanttType.DeleteRightLabel, "Delete Right Label");
            this.closeContext();
        }
        insertHyperLink() {
            let view = window["_view"];
            // if(view._activeShape && view._activeShape.toGantt()){
            //     let gantt = view._activeShape.toGantt();
            //     let vecSels = [];
            //     gantt.getSelectedTasks(vecSels);
            //     if(vecSels.length !=0){
            //         gantt._clickHypTaskID = vecSels[0]._id;
            //     }
            // }
            this.$store.commit("setDialogState", {
                type: "dialogType",
                data: "hyperlink",
            });
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: "true",
            });
            this.closeContext();
        }
        InsertColumn() {
            this.$store.commit("setDialogState", {
                type: "dialogType",
                data: "GanttColumnAdd",
            });
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: true,
            });
            this.closeContext();
        }
        HideColumn() {
            let view = window["_view"];
            view.ganttOperation(eGanttType.HideColumn, "Hide Column");
            this.closeContext();
        }
        DeleteColumn() {
            let view = window["_view"];
            view.ganttOperation(eGanttType.DeleteColumn, "Delete Column");
            this.closeContext();
        }

        moveColumnToForward() {
            let view = window["_view"];
            view.ganttOperation(eGanttType.MoveColToForward, "movet Column to left");
            this.closeContext();
        }

        moveColToBack() {
            let view = window["_view"];
            view.ganttOperation(eGanttType.MoveColToBack, "movet Column to right");
            this.closeContext();
        }

        clickOption() {
            if (!this.isGantt) return;
            let view = window["_view"];
            this.$track("rightPanel", "gantt", "set GanttOption");
            this.$store.commit("setDialogState", {
                type: "dialogType",
                data: "GanttOption",
            });
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: true,
            });
            this.closeContext();
        }
        showGanttFloatPanel() {
            let flag: boolean = !EDDocument._gcfg._showGanttFloatPanel;
            EDDocument._gcfg._showGanttFloatPanel = flag;
            this.closeContext();
        }
        getShowCol() {
            let pGantt: any = window["_view"].getGantt();
            let num = 0;
            if (pGantt) {
                let arr = pGantt._lstCols.filter((item, index) => {
                    return !item._isHiden;
                });
                num = arr.length;
            }
            return num;
        }
        showColNum = 0;
        mounted() {
            this.showColNum = this.getShowCol();
        }
        get contextStyle() {
            return {
                maxHeight: window.innerHeight,
            };
        }

        get isMoveColToLeftEnable() {
            return this.$store.state.gantt.canMoveColumnToLeft;
        }

        get isMovetColToRightEnable() {
            return this.$store.state.gantt.canMoveColumnToRight;
        }

        get isGantt() {
            return this.$store.state.shape.type == "Gantt";
        }
        get isSelectRow() {
            return this.$store.state.shape.isSelectGanttRow;
        }
        get isSelectColumn() {
            return this.$store.state.shape.isSelectGanttColumn;
        }
        get isExpandAllSubTask() {
            return this.$store.state.gantt.isExpandAllTask;
        }
        get isHideAllSubTask() {
            return this.$store.state.gantt.isHideAllTask;
        }
        get isCanMoveUpTask() {
            return this.$store.state.gantt.canMoveUpTasks;
        }
        get isCanMoveDownTask() {
            return this.$store.state.gantt.canMoveDownTasks;
        }
        get isGanttItem() {
            return this.$store.state.shape.isActived;
        }
        get isIndent() {
            return this.$store.state.gantt.isIndent;
        }
        get isOutdent() {
            return this.$store.state.gantt.isOutdent;
        }
        get isNull() {
            return this.$store.state.gantt.isNull;
        }
        get isAddLeftLabel() {
            return this.$store.state.gantt.canAddLeftLabel;
        }
        get isAddRightLabel() {
            return this.$store.state.gantt.canAddRightLabel;
        }
        get group() {
            return this.$store.state.shape.isMultiSel;
        }
        get isSelectAll() {
            return this.$store.state.gantt.selectAll;
        }
        get isSelectTask() {
            return this.$store.state.gantt.selectTask;
        }
        get isSelectIdOrNameColumn() {
            return this.$store.state.gantt.selectGanttColumnName;
        }
        get isShowGanttFloatPanel() {
            return EDDocument._gcfg._showGanttFloatPanel;
        }
    }
</script>
